import React, { Component } from "react";
import { Container,Col ,Row,UncontrolledDropdown ,DropdownToggle,DropdownMenu,Form} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Calender from '../calender';
import {connect } from 'react-redux';
import {
  faMapMarkerAlt, faSearch,
} from '@fortawesome/free-solid-svg-icons'
import { withRouter } from "react-router-dom";
import 'bootstrap'


class AdvencedSearchVisas extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);

  }
  state = {
    advancedSearch: { destination: '',startDate:"",endDate:'',nbrChambres:1,nbrEnfant:1,nbrAdultes:1},
    clikedDetailInput:false
  }

  onInputChange(evt) {
    this.setState({
      advancedSearch: {
        ...this.state.advancedSearch,
        [evt.target.name]: evt.target.value
      }
    })
  }

  onFormSubmit(evt) {
    evt.preventDefault()
    this.props.dispatch({type: "ADVANCED_SEARCH",payload:this.state.advancedSearch});
    this.props.history.push('/visas/advanced_search');
  }
  render() {
    const { nbrChambres, nbrEnfant, nbrAdultes} = this.state.advancedSearch
    return (
      <>
        {/* Mobile */}
        <Container className="mobile-view-search-bar">
          <Row>
            <Col sm="7" md="12">
              <div className="left-search">
                <Col sm="7" className="view-search" >
                  <div className="destination-input phone-view-first">
                    <UncontrolledDropdown nav inNavbar>
                      <DropdownToggle id="destination" className="filter-element left-radius" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold", fontSize: "15px", height: "36px" }}>
                        Votre Destination
                        <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big" />
                      </DropdownToggle>
                      <Row>
                        <DropdownMenu className="destination-drop-down">
                          <div>
                            <input type="text" className="input-destination" placeholder="Rechercher un Pays/Ville.." />
                            <div className="body-drop-down">

                              <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>

                              <hr />
                              <div className="result-block">
                                <div className="result-search">
                                  <FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>
                                  Skikda,Algérie</div>
                                <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Oran,Algérie</div>
                                <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Relizane,Algérie</div>
                              </div>
                              <span id="recent-title">Récents</span>
                              <hr />
                              <div className="result-block">
                                <div className="recent"><FontAwesomeIcon icon={faSearch} />Skikda,Algérie</div>
                                <div className="recent"><FontAwesomeIcon icon={faSearch} />Ibiza,Espagne</div>
                                <div className="recent"><FontAwesomeIcon icon={faSearch} />Dubai,UAE</div>
                              </div>
                            </div>
                          </div>
                        </DropdownMenu>
                      </Row>
                    </UncontrolledDropdown>
                  </div>
                </Col>
              </div>
              <div className="right-search">
                <Col sm="5" className="view-search">
                  <div className="destination-input phone-view-second">
                    <UncontrolledDropdown nav inNavbar >
                      <DropdownToggle id="destination" className="Advanced-btn-ser" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold", fontSize: "15px", height: "36px" }}>
                        Départ Prévu
                        <img style={{ width: "20px", marginTop: "3px" }} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" id="arrow-parcourir-big" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <Calender />
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </Col>
              </div>
            </Col>

            <Col sm="5">
              <Row>
                <div className="left-search-2nd-ligne">
                  <Col sm="8" className="view-search" >
                    <div className="destination-input">
                      <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle id="destination" className="Advanced-btn-ser" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold", fontSize: "15px", height: "41px", marginTop: "6px" }}>
                          Retour Prévu
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big" />
                        </DropdownToggle>
                        <DropdownMenu left className="detail-drop-down">
                          <span className="label-detail-search">Adultes <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrAdultes" value={nbrAdultes} /></span></span>
                          <span className="label-detail-search">Enfant  <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrEnfant" value={nbrEnfant} /></span></span>
                          <span className="label-detail-search">Chambres <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrChambres" value={nbrChambres} /></span></span>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Col>
                </div>

                <div className="right-search-2nd-ligne">
                  <Col sm="4" className="view-search">
                    <div className="destination-input">
                      <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle id="recherche-button" style={{ width: "100%", backgroundColor: "#37296a", color: "white", textAlign: "left", fontWeight: "bold", fontSize: "15px", height: "40px", marginTop: '6px' }} onClick={this.onFormSubmit.bind(this)}>
                          Recherche
                          <img src="/imgs/navebar/search.svg" alt="" id="recherche" />
                        </DropdownToggle>
                        <DropdownMenu right>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
          <Row>
          </Row>
          <div className="after-search">
            <div className="line-after-search"></div>
            <div className="title-after-search"><p className="text-after-search">Recherchez par type d'hébergement</p></div>
          </div>
        </Container>










        {/* view desktop **************** */}
        <Container className="desktop-view-search-bar">
          <Form onChange={this.onInputChange.bind(this)} >
            <Row>
              <Col sm="4" className="pr-0">
                <div className="destination-input">
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle id="destination" className="filter-element left-radius" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold" }}>
                      Votre Destination
                      <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big" />
                    </DropdownToggle>
                    <Row>
                      <DropdownMenu className="destination-drop-down">
                        <div>
                          <input type="text" name="destination" className="input-destination" placeholder="Rechercher un Pays/Ville.." />
                          <div className="body-drop-down">

                            <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>

                            <hr />
                            <div className="result-block">
                              <div className="result-search">
                                <FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>
                                Skikda,Algérie</div>
                              <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Oran,Algérie</div>
                              <div className="result-search"><FontAwesomeIcon id="position-icon-result" icon={faMapMarkerAlt}></FontAwesomeIcon>Relizane,Algérie</div>
                            </div>
                            <span id="recent-title">Récents</span>
                            <hr />
                            <div className="result-block">
                              <div className="recent"><FontAwesomeIcon icon={faSearch} />Skikda,Algérie</div>
                              <div className="recent"><FontAwesomeIcon icon={faSearch} />Ibiza,Espagne</div>
                              <div className="recent"><FontAwesomeIcon icon={faSearch} />Dubai,UAE</div>
                            </div>
                          </div>
                        </div>
                      </DropdownMenu>
                    </Row>
                  </UncontrolledDropdown>
                </div>
              </Col>
              <Col sm="3" className="p-0">
                <div className="destination-input">
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle id="destination" className="filter-element rounded-0" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold" }}>
                      Départ Prévu
                      <img style={{ width: "20px", marginTop: "3px" }} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" id="arrow-parcourir-big" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <Calender />
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>

              <Col sm="3" className="pl-0 pr-2">
                <div className="destination-input">
                  <UncontrolledDropdown nav inNavbar onClick={() => { this.setState({ clikedDetailInput: true }) }}>
                    <DropdownToggle id="destination" className="filter-element right-radius" style={{ width: "100%", backgroundColor: "white", color: "#37296a", textAlign: "left", fontWeight: "bold" }}>
                      <img style={{ width: "20px", marginTop: "3px" }} src="/imgs/ghurfatiFilter/calendar_icn.svg" alt="" id="arrow-parcourir-big" />
                      Retour Prévu
                    </DropdownToggle>
                    <DropdownMenu left className="detail-drop-down">
                      <span className="label-detail-search">Adultes <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrAdultes" value={nbrAdultes} /></span></span>
                      <span className="label-detail-search">Enfant  <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrEnfant" value={nbrEnfant} /></span></span>
                      <span className="label-detail-search">Chambres <span><input className="detail-input" min="1" defaultValue="1" type="number" name="nbrChambres" value={nbrChambres} /></span></span>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
              <Col sm="2" className="pl-1">
                <div className="destination-input">
                  <UncontrolledDropdown nav inNavbar>
                    <DropdownToggle id="recherche-button" style={{ width: "100%", backgroundColor: "#37296a", color: "white", textAlign: "left", fontWeight: "bold" }} onClick={this.onFormSubmit.bind(this)}>
                      Recherche
                      <img src="/imgs/navebar/search.svg" alt="" id="recherche" />

                    </DropdownToggle>
                  </UncontrolledDropdown>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>

      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    // startDate: state.counterApp.startDate,
    // endDate: state.counterApp.endDate,
  }
}
//connect function INJECTS dispatch function as a prop!!
// export default connect(mapStateToProps)(AdvencedSearchGhurfaty);
export default withRouter(connect(mapStateToProps)(AdvencedSearchVisas));

